import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'

import {CodeViewEditor} from '../components/CodeViewEditor'
import {codeViewEditRoute} from '../routes/code-view-edit-route'
import {CodeView} from './CodeView'

export function CodeViewEditEntrypoint() {
  const {data: payload} = useRouteQuery(codeViewEditRoute, 'mainQuery')

  return (
    <div className="tmp-pt-3">
      <CodeView payload={payload} action="edit">
        {() => (
          <CodeViewEditor
            editInfo={payload.editInfo}
            path={payload.path}
            webCommitInfo={payload.webCommitInfo}
            copilotInfo={payload.copilotInfo}
            copilotGenerateCommitMessageAuthInfo={payload.copilotGenerateCommitMessageAuthInfo}
          />
        )}
      </CodeView>
    </div>
  )
}
